// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"890123b6","771":"1b6e43cd","882":"2cd0e71f","924":"b5747365"}[chunkId] + ".chunk.css";
};